function esquistossomose(){
    return{
        "games":[
            {
                "informs":[
                    {
                    "text":"No ciclo da doença, estão envolvidos dois hospedeiros, o definitivo, homem, e o intermediário, caramujos do gênero Biomphalaria: B. <i>glabrata</i>, B. <i>tenagophila</i> e B. <i>straminea</i>.",
                    "title":"Quem está envolvido no ciclo da doença?",
                    "image":"images/games/informs/esqui/1.png"
                    },
                    {
                    "text":"No homem o parasita chega à forma adulta, reproduz-se sexuadamente e elimina ovos no através das fezes, contaminando a água onde estão (lagos, lagoas, açudes),",
                    "title":"Quem está envolvido no ciclo da doença?",
                    "image":"images/games/informs/esqui/1.png"
                    },
                    {
                    "text":"Primatas, marsupiais, ruminantes e roedores também são considerados hospedeiros permissivos ou reservatórios, mas, não está clara a participação desses animais na transmissão.",
                    "title":"Quem está envolvido no ciclo da doença?",
                    "image":"images/games/informs/esqui/1.png"
                    }
                ],
                "pathImageGame":"midias/images/games/puzzles/esqui/1.jpg"
            },
            {
                "informs":[
                {
                        "text":"Aproximadamente 45 dias após a infecção, os vermes Schistosoma <i>mansoni</i> já são adultos e se alojam nas veias abdominais podendo ali viver até 20 anos.",
                        "title":"Quem causa a doença?",
                        "image":"images/games/informs/esqui/2.png"
                    },
                {
                        "text":"A fêmea elimina aproximadamente 300 ovos por dia, grande parte eliminada junto às fezes. Contudo, alguns ovos ficam retidos no intestino e nos capilares abdominais do hospedeiro,",
                        "title":"Quem causa a doença?",
                        "image":"images/games/informs/esqui/2.png"
                    },
                {
                        "text":"onde desencadeiam reações inflamatórias, que pode levar ao aumento da pressão em tais veias, aumento do volume abdominal, e de órgãos como fígado e baço. ",
                        "title":"Quem causa a doença?",
                        "image":"images/games/informs/esqui/2.png"
                    }
                ],
            "pathImageGame":"midias/images/games/puzzles/esqui/2.jpg"
        },
        {
            "informs":[
                {
                    "text":"Até 5 dias após a penetração da cercária na pele, manifesta-se a dermatite cercariana, coceira no local.",
                    "title":"Quais os sintomas da doença?",
                    "image":"images/games/informs/esqui/3.png"
                },
                {
                    "text":"Após 3 a 7 semanas, pode ocorrer febre, dores de barriga e cabeça, náusea, vômito, tosse seca, emagrecimento e aumento do fígado. ",
                    "title":"Quais os sintomas da doença?",
                    "image":"images/games/informs/esqui/3.png"
                },
                {
                    "text":"Em aproximadamente 45 dias, se instala a fase crônica na qual ocorrem dores abdominais, sangue nas fezes e aumento do fígado associado ao acúmulo de líquido na barriga, sintoma característico da doença, origem de seu nome popular “barriga d’água”.",
                    "title":"Quais os sintomas da doença?",
                    "image":"images/games/informs/esqui/3.png"
                }
            ],
            "pathImageGame":"midias/images/games/puzzles/esqui/3.jpg"
        },
        {
            
            "informs":[
                {
                    "text":"Ao defecar próximo à rios e lagos, indivíduos contaminados com Schistosoma <i>mansoni</i> eliminam ovos que eclodem em contato com água doce, liberando miracídios.",
                    "title":"Como a doença é transmitida?",
                    "image":"images/games/informs/esqui/4.png"
                },
                {
                    "text":"Estes infectam o caramujo: o hospedeiro intermediário da doença, em seu interior transformam-se em cercarias e são liberadas na água.",
                    "title":"Como a doença é transmitida?",
                    "image":"images/games/informs/esqui/4.png"
                },
                {
                    "text":"No contato com água contaminada, as cercarias penetram na pele do homem, infectando-o e transformam-se em esquistossômulos, que migram para os pulmões e depois se alojam nas veias do fígado.",
                    "title":"Como a doença é transmitida?",
                    "image":"images/games/informs/esqui/4.png"
                }
            ],
            "pathImageGame":"midias/images/games/puzzles/esqui/4.jpg"        
        },
        {
             "informs":[
                {
                    "text":"A prevenção consiste na identificação e no tratamento de pessoas doentes, no combate aos caramujos e em ações educativas junto à sociedade.",
                    "title":"Como fazer a prevenção?",
                    "image":"images/games/informs/esqui/5.png"
                },
                {
                    "text":"Evitar o contato com águas contaminadas por cercarias é importante, pois estas infectam o homem por penetração na pele com ou sem lesões.",
                    "title":"Como fazer a prevenção?",
                    "image":"images/games/informs/esqui/5.png"
                },
                {
                    "text":"Locais com água doce de pouca correnteza ou parada, utilizados para atividades profissionais ou de lazer, como banhos, pescas ou plantio de culturas irrigadas são propícios para o crescimento do molusco.",
                    "title":"Como fazer a prevenção?",
                    "image":"images/games/informs/esqui/5.png"
                }
            ],
            "pathImageGame":"midias/images/games/puzzles/esqui/5.jpg"        
        }
    ]
  }
}

export{esquistossomose};